/**
 * DOMI-CARE - Catálogo Nacional de Obras Sociales, Prepagas y Mutuales
 * Incluye catálogo base nacional y sincronización con coberturas personalizadas.
 */

// Catálogo base de obras sociales provisto para Argentina
export const OBRAS_SOCIALES_BASE = [
  "A.M.B.P.B.A",
  "AGUA Y ENERGIA",
  "AMFFA",
  "AMS",
  "APSOT",
  "ATSA",
  "AVALIAN",
  "AVALIAN INTE",
  "AVERA",
  "BOREAL",
  "BRAMED",
  "CONEXION AMB",
  "CONEXION INT",
  "CPCES",
  "CRUZ MED SA",
  "EMASALUD",
  "ENSALUD-AMB",
  "ENSALUD-INTE",
  "ESCRIBANOS",
  "FARMACIA",
  "G.C.G. MOSAI",
  "GALENO",
  "GALENO ARG",
  "GALENO CONSU",
  "HEMISFERIO",
  "HOPE - PERFU",
  "HUESPED",
  "IOMA",
  "IOSFA",
  "IOSFA-INT",
  "IPS",
  "JERARQUICOS",
  "LUIS PASTEUR",
  "LUZ Y FUERZA",
  "MEDICAL GROU",
  "MEDICUS ABC",
  "MEDIFE",
  "MEP LIFE",
  "MUTUAL23-AMB",
  "MUTUAL23-INT",
  "NOBIS AMBULA",
  "O.S.D.I.P.P.",
  "O.S.M.A.T.A",
  "O.S.P.E.",
  "OMINT S.A",
  "OPDEA",
  "OS FUTBOLIST",
  "OS.SAN PEDRO",
  "OSBA - COVID",
  "OSBA-C.E.S",
  "OSDE",
  "OSDE - AMBUL",
  "OSDE - INTER",
  "OSDEPyM",
  "OSECAC",
  "OSECAC AMBUL",
  "OSEIV",
  "OSETRA",
  "OSFATUN",
  "OSMATA",
  "OSPATCA",
  "OSPAV-C.E.S",
  "OSPE INTERNA",
  "OSPE PMO",
  "OSPEC-CES",
  "OSPERHYRA",
  "OSPESGA",
  "OSPF",
  "OSPIF PLATIN",
  "OSPIL",
  "OSPLAD",
  "OSSEG",
  "OSUTHGRA",
  "PAMI",
  "PARTICULAR",
  "PATRO-INTERN",
  "PATRON-AMBUL",
  "POD JUD AMBU",
  "POD JUD INTE",
  "POLICIA FEDE",
  "PREMIER",
  "PREVEN.SALUD",
  "PROP MEDICA",
  "RED DE SEGUR",
  "RIOMED-OSPM",
  "ROI SA",
  "ROI-PANADERO",
  "SADAIC",
  "SAJU",
  "SALUTEM",
  "SANCOR SALUD",
  "SCIS S.A.",
  "SENDEROS",
  "SER.PENITENC",
  "SWISS MEDICAL",
  "TV SALUD",
  "UNION PERSON",
  "UNSA - ALTA",
  "UNSA - INTER",
  "UNSA - TERAP",
  "UNSA AMB",
  "UTA"
];

const STORAGE_KEY = 'domicare_custom_obras_sociales';

/**
 * Obtiene la lista completa de obras sociales uniendo la base nacional
 * con cualquier obra social añadida dinámicamente por la institución.
 */
export function getObrasSocialesList() {
  let customList = [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      customList = JSON.parse(raw);
    }
  } catch (e) {
    console.warn('[ObrasSociales] Error al leer custom de localStorage', e);
  }

  // Unir, desduplicar y ordenar alfabéticamente (A-Z)
  const combined = Array.from(new Set([...OBRAS_SOCIALES_BASE, ...customList]))
    .map(os => os.trim())
    .filter(Boolean)
    .sort((a, b) => a.localeCompare(b, 'es', { sensitivity: 'base' }));

  return combined;
}

/**
 * Registra una nueva obra social en el catálogo permanente
 * @param {string} nombre Nombre o Sigla de la Obra Social
 * @returns {{success: boolean, name: string, isNew: boolean, list: string[]}}
 */
export function registrarNuevaObraSocial(nombre) {
  if (!nombre || typeof nombre !== 'string') {
    return { success: false, error: 'Nombre inválido' };
  }

  const cleanName = nombre.trim().toUpperCase();
  if (cleanName.length < 2) {
    return { success: false, error: 'El nombre debe tener al menos 2 caracteres' };
  }

  let customList = [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      customList = JSON.parse(raw);
    }
  } catch (e) {
    customList = [];
  }

  const currentList = getObrasSocialesList();
  const exists = currentList.some(item => item.toUpperCase() === cleanName);

  if (!exists) {
    customList.push(cleanName);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(customList));
    } catch (e) {
      console.error('[ObrasSociales] Error al guardar en localStorage', e);
    }
  }

  const updatedList = getObrasSocialesList();
  return {
    success: true,
    name: cleanName,
    isNew: !exists,
    list: updatedList
  };
}
